import React from 'react';
import { Star } from 'lucide-react';

const Feedback = () => {
    return (
       <>
       <section className="py-5" style={{backgroundColor: '#1a1a1a'}}>
        <div className="container py-5">
          {/* Section Title */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="display-4 text-white fw-normal">Feedback From Our Clients</h2>
            </div>
          </div>

          {/* Testimonials Grid */}
          <div className="row g-4">
            {/* First Testimonial */}
            <div className="col-lg-6">
              <div className="testimonial-card">
                {/* Star Rating */}
                <div className="star-rating">
                  {[...Array(5)].map((_, index) => (
                    <Star key={index} size={20} className="star-filled" fill="currentColor" />
                  ))}
                </div>

                {/* Testimonial Content */}
                <div className="testimonial-content">
                  <p className="mb-3">
                     They did a great job, they were able to start quickly 
                    and worked on Sat and bank holiday to get it done.
                  </p>
                  <p className="mb-3">
                    They put up an interior wall and installed new doors / made 1 
                    new doorway.
                  </p>
                  <p className="mb-3">Moved a radiator</p>
                  <p className="mb-3">And re papered and decorated</p>
                  <p className="mb-3">They are very responsive and the price was good</p>
                  <p className="mb-0">The builders were clean and tidy</p>
                </div>
              </div>
            </div>

            {/* Second Testimonial */}
            <div className="col-lg-6">
              <div className="testimonial-card">
                {/* Star Rating */}
                <div className="star-rating">
                  {[...Array(5)].map((_, index) => (
                    <Star key={index} size={20} className="star-filled" fill="currentColor" />
                  ))}
                </div>

                {/* Testimonial Content */}
                <div className="testimonial-content">
                  <p className="mb-0">
                    Ideal for house renovations and interior design. The team is 
                    professional, tidy, and efficient. Will definitely recommend 
                    them to friends.
                  </p>
                </div>

                {/* Client Info */}
                <div className="client-info">
                  <div className="client-name">Lesya Klovak</div>
                  <div className="client-services">
                    Tile work installation, Floor fitting, Tile work replacement, Demolition, 
                    Interior decorating, Refurbishment, Remodelling, Plumbing fixture 
                    installation, Flooring repair, Furniture assembly
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       
       
       </>
    );
};

export default Feedback;